<template>
    <div class="form-group">
        <label :for="id">{{ attribute.attribute_name }}</label>
        <input type="number" :name="name" :id="id" @input="onChange" :value="this.numberValue">
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
    name: "NumberAttribute",
    props: {
        attribute: {
            type: Object,
            required: true
        },
        value: null,
        clone: 0
    },
    data() {
        return {
            numberValue: this.value
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        }
    },
    methods: {
        onChange(event) {
            this.numberValue = event.target.value
            this.$emit('input', event.target.value)
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribtue,
                value: this.numberValue
            })
        }
    }
}
</script>

<style scoped>

</style>